<div class="toast"
     [style.visibility]="(visible || animate) ? 'visible' : 'hidden'"
>
  <div class="message" [ngClass]="level"
       [style.animation]="animate ? (visible ? 'fadeIn 0.5s' : 'fadeOut 0.3s') : ''"
       (animationend)="onAnimationEnd()"
       (click)="hide()"
       *ngIf="(visible || animate)"
  >
    <mat-icon svgIcon="toast"></mat-icon>
    {{ message | translate }}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/toast/toast.component.html